
import { useAuthContext } from '@/contexts/auth';
import { useState, useEffect } from 'react';

export const useAuth = () => {
  const auth = useAuthContext();
  const { user, isAuthenticated, isLoading } = auth;
  
  const [role, setRole] = useState<string>('user');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isDealer, setIsDealer] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      console.log("[useAuth] Auth state:", { isAuthenticated, user, isLoading });
      
      if (isAuthenticated && user) {
        console.log("[useAuth] Authenticated user, checking role for:", user.id);
        
        // Get the user's role, defaulting to 'user'
        const userRole = user.role || '';
        const normalizedRole = typeof userRole === 'string' 
          ? userRole.toLowerCase() 
          : 'user';
        
        setRole(normalizedRole);
        setIsAdmin(normalizedRole === 'admin' || normalizedRole === 'super_admin');
        setIsSuperAdmin(normalizedRole === 'super_admin');
        setIsDealer(normalizedRole === 'dealer');
        
        console.log("[useAuth] Role set to:", normalizedRole);
      } else {
        console.log("[useAuth] Not authenticated, using default 'user' role");
        setRole('user');
        setIsAdmin(false);
        setIsSuperAdmin(false);
        setIsDealer(false);
      }
    } catch (error) {
      console.error("[useAuth] Error in useEffect:", error);
      setRole('user');
      setIsAdmin(false);
      setIsSuperAdmin(false);
      setIsDealer(false);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user, isLoading]);

  return {
    ...auth, // Pass all properties and methods from the original context
    role,
    isAdmin,
    isSuperAdmin,
    isDealer,
    loading: loading || isLoading
  };
};

export default useAuth;
